import { useState, useEffect, useRef } from 'react'
import { reaction } from 'mobx'
import { FormField } from '@/Core/UI/Form'
import { FormContextProvider, createFormContext } from '@/Core/UI/Form/Providers'

const CellFieldTemplate: React.FC<{ field: any; children: React.ReactNode }> = ({ children }) => <>{children}</>

export interface AssignmentFormFieldCellProps {
    fieldName: string
    fieldDef: Record<string, any>
    initialValue: any
    initialIri: string | null
    onSave: (iri: string | null) => void
    onSaveObject?: (value: any) => void
    disabled: boolean
}

export const AssignmentFormFieldCell: React.FC<AssignmentFormFieldCellProps> = ({
    fieldName,
    fieldDef,
    initialValue,
    initialIri,
    onSave,
    onSaveObject,
    disabled,
}) => {
    const savedIri = useRef(initialIri)

    const [formStore] = useState(() =>
        createFormContext({
            fields: { [fieldName]: { ...fieldDef, isEditable: true } },
            initialValues: { [fieldName]: initialValue },
            isEditable: true,
        })
    )

    useEffect(() => {
        const dispose = reaction(
            () => formStore.getValue(fieldName),
            (val: any) => {
                const newIri = !val ? null : typeof val === 'string' ? val : (val as any)['@id'] ?? null
                if (newIri !== savedIri.current) {
                    savedIri.current = newIri
                    onSave(newIri)
                    onSaveObject?.(typeof val === 'object' && val !== null ? val : null)
                }
            }
        )
        return () => dispose()
    }, [formStore, fieldName, onSave, onSaveObject])

    return (
        <div style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}>
            <FormContextProvider value={formStore}>
                <FormField name={fieldName} template={CellFieldTemplate} ignoreParentField={true} />
            </FormContextProvider>
        </div>
    )
}
